<template>
  <!-- MEMORY LEAK https://github.com/KoRiGaN/Vue2Leaflet/issues/410 -->
  <l-map
    id="mini-map"
    ref="map"
    class="mini-map"
    :style="{height: size, width: size}"
    :zoom="zoom"
    :center="location"
    :options="options"
    @mouseover="hover=true"
    @mouseout="hover=false"
  >
    <l-tile-layer :url="basemap.url" />
    <l-marker :lat-lng="location" />
  </l-map>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import defaultMaps, { BasemapDefault } from '@/components/builder/MapSettings/defaultMaps'
import { BasemapTypes } from '@/types'
import { SEARCH_CONFIG_KEY } from '@/constants'

const components = {
  LMap, LTileLayer, LMarker,
}

const props = {
  location: {
    type: Array,
    required: true,
  },
}

@Component({ components })
export default class MiniMap extends Vue.extend({ props }) {
  hover = false
  size = '120px'

  get basemapType () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config[SEARCH_CONFIG_KEY].basemapType
  }

  get basemapDefault () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config[SEARCH_CONFIG_KEY].basemapDefault
  }

  get basemapCustom () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config[SEARCH_CONFIG_KEY].basemapCustom
  }

  get options () {
    return {
      zoomControl: false,
      attributionControl: false,
      dragging: false,
      doubleClickZoom: false,
      boxZoom: false,
      scrollWheelZoom: false,
      touchZoom: false,
    }
  }

  get zoom () {
    return this.hover ? 15 : 12
  }

  get basemap () {
    if (this.basemapType === BasemapTypes.DEFAULT) {
      return defaultMaps.find((i: BasemapDefault) => i.id === this.basemapDefault) || defaultMaps[0]
    } else if (this.basemapType === BasemapTypes.CUSTOM) {
      return this.basemapCustom
    } else {
      // Should throw an Error here and give feedback to the client
      return {
        url: '',
        attribution: '',
      }
    }
  }
}

</script>

<style scoped>

.mini-map {
  z-index: -1;
}

</style>
